import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: 2.4rem;
`;
